import { render, staticRenderFns } from "./MarsDATAPlanet.vue?vue&type=template&id=fa821dfc&scoped=true&"
import script from "./MarsDATAPlanet.vue?vue&type=script&lang=js&"
export * from "./MarsDATAPlanet.vue?vue&type=script&lang=js&"
import style0 from "./MarsDATAPlanet.vue?vue&type=style&index=0&id=fa821dfc&lang=scss&scoped=true&"
import style1 from "./MarsDATAPlanet.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa821dfc",
  null
  
)

export default component.exports